module.exports = __webpack_public_path__ + "static/img/3.5b8ee5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/5/3.png
// module id = +YcO
// module chunks = 0